<template>
  <div class="bargainPriceBox">
    <div class="tabbar">
      <div id="tabbar">
        <div
          class="tabbarItem"
          :class="item === selectItem ? 'isAcitve' : ''"
          v-for="(item, index) in tabbarItem"
          :key="index"
          @click="clickItem(item, index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="filter_search">
        <input
          type="text"
          class="filter_search_input"
          v-model="query.match"
          placeholder="请输入账户关键词"
        />
        <span class="filter_search_btn" @click="handleSearch">确认</span>
      </div>
    </div>
    <div class="filter">
      <div class="select_ground">
        <div class="select_data">
          <el-select
            v-model="query.type"
            :popper-append-to-body="false"
            placeholder="选择时间"
            clearable
            @change="handleSearch"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select_game">
          <el-select
            v-model="query.game_id"
            clearable
            :popper-append-to-body="false"
            placeholder="选择游戏"
            @change="handleSearch"
          >
            <el-option
              v-for="(item, index) in selectGame"
              :key="index"
              :label="item.game_name"
              :value="item.game_id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-radio-group
      class="status-filter"
      v-model="query.status"
      fill="#1A1D24"
      text-color="#1A1D24"
      @input="handleSearch"
    >
      <el-radio-button label="0">进行中</el-radio-button>
      <el-radio-button label="1">议价成功</el-radio-button>
      <el-radio-button label="2">议价失败</el-radio-button>
    </el-radio-group>
    <div class="product" v-if="totalCount !== 0">
      <div class="product-list">
        <div
          class="product-list-item"
          v-for="item in tableData"
          :key="item.id"
          @click="tableRowClick(item)"
        >
          <img :src="item.image" class="left-image" alt="" />
          <div class="order">
            <div class="order-num">
              <div class="order-num-left">
                <img src="@/assets/image/bargin/bargin-logo.png" alt="" />
                <span>商品编号：{{ item.unique_no }}</span>
              </div>
              <div class="order-num-right" v-show="item.status != 2">
                <template v-if="item.counter_status == 4 || item.counter_status == 2 || item.counter_status == 1">
                  买家出价：￥{{item.buyer_price}}
                  <div class="my-counteroffer" v-if="item.seller_price > 0 && item.counter_status == 4">
                    我的还价:
                    <span class="price-icon">￥</span>
                    <span class="price-text">{{item.seller_price}}</span>
                  </div>
                </template>
                <div class="my-counteroffer" v-show="(item.tail_order_add_time || item.counter_status == 3 || item.counter_status == 5) && item.status !== 2">
                    到手价:
                    <span class="price-icon">￥</span>
                    <span class="price-text">{{  item.pay_amount }}</span>
                  </div>
                <template v-if="item.counter_status == 2 || item.counter_status == 3 || item.counter_status == 5 || item.counter_status == 6">
                  <div class="agree" v-show="item.counter_status == 3 && item.status === 0 && item.step < 3">已同意</div>
                  <div class="refund" v-show="item.counter_status == 2">已拒绝</div>
                </template>
              </div>
            </div>
            <div class="order-title">{{item.game_name + item.product_name }}</div>
            <div class="rowData-footer">
              <my-progress
                :rowData="item"
                @payOverTime="payOverTime"
              >
              </my-progress>
              <btn-group
                :rowData="item"
                @counteroffer="handleCounteroffer(item)"
                @agreeUpset=" e => {handleAgreeUpset(e,item)}"
                @pullPlugUpset="handlePullPlugUpset(item.id)"
                @hasten="hasten(item.id)"
                @sendPsd="handleSendPsd(item)"
                :button_list="item.button_list"
                @cusSerBtnClicks="$openIM({
                  im_type: 3,
                  roomId: item.room_id
                })"
                @GoGroup="item.group_room_id ? $openIM({
                  im_type: 3,
                  roomId: item.group_room_id
                }) : ()=>{}"
                @closeRemind="closeRemindClick(item.id)"
                @nextUrgeTimeChange="nextUrgeTimeChange(item)"
              >
              </btn-group>
            </div>
          </div>
        </div>
      </div>
      <div class="pages">
        <common-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="query.page"
          :page-size="query.pageSize"
          layout="prev, pager, next, jumper"
          :total="totalCount"
        >
        </common-pagination>
      </div>
    </div>
    <div class="no_data" v-else>
      <empty-state
        title="暂无议价订单"
        description="可以调整筛选条件后再次查看"
        icon="el-icon-price-tag"
        :icon-size="52">
      </empty-state>
    </div>
    <!-- 求降价信息详情 -->
    <downturnDeatilDia
      :show.sync="downturnDeatilDiaShow"
      :rowDetail="rowDetail"
    >
      <div slot="btn" class="downturn-group-btn">
        <el-button
          :disabled="disabled"
          v-preventReClick='1000'
          v-show="button_list.indexOf(115)>=0"
          @click="$openIM({
            im_type: 3,
            roomId: rowDetail.room_id
          })"
          class="btn"
        >客服</el-button>
        <el-button :disabled="disabled" v-preventReClick='1000' v-show="button_list.indexOf(111)>=0 || button_list.indexOf(113)>=0" @click="handleVerificationReport(rowDetail.id)" class="btn w-88" :class="{'bg-FFDB51':button_list.indexOf(113)>=0}">验号报告</el-button>
        <btn-group
          :rowData="rowDetail"
          @counteroffer="handleCounteroffer(rowDetail)"
          @agreeUpset=" e => {handleAgreeUpset(e,rowDetail)}"
          @pullPlugUpset="handlePullPlugUpset(rowDetail.id)"
          @hasten="hasten(rowDetail.id)"
          @sendPsd="handleSendPsd(rowDetail)"
          :button_list="button_list"
          @cusSerBtnClicks="$openIM({
            im_type: 3,
            roomId: rowDetail.room_id
          })"
          @GoGroup="rowDetail.group_room_id ? $openIM({
            im_type: 3,
            roomId: rowDetail.group_room_id
          }) : ()=>{}"
          @closeRemind="closeRemindClick(rowDetail.id)"
          @nextUrgeTimeChange="nextUrgeTimeChange(rowDetail)"
        >
        </btn-group>
      </div>
    </downturnDeatilDia>
    <!-- 终止弹窗 -->
    <pullPlugUpset
      :show.sync="pullPlugUpsetShow"
      :id="rowId"
      @refreshData="handleGetData()"
    >
    </pullPlugUpset>
    <!-- 告知书 -->
    <myDialog
      :show="noticeShow"
      :title="'告知书'"
      boxPadding="20px"
      :closeFun="() => {noticeShow=false}"
      width="422"
      top="20vh"
      dialog-style="header"
    >
      <div slot="content" class="notice-content">
        <p>1.您在游严选平台出售游戏账号需要签署电子合同（签署合同时需要提供相关个人信息材料，包括但不限于：身份信息，实名收款账号信息）。若您出售首任游戏账号需要提供一个月内真实有效的订单截图。</p>
        <p class="tips">友情提醒：支付宝账号到账较快，微信、银行卡到账较慢。</p>
        <p>2.若您的游戏账号在多个平台寄售，请保持寄售价格一致，否则账号会被下架；若同一账号多次下单后无理由不交付，默认您有违诚信，平台会下架并联系其他平台拉黑处理该 账号。若您寄售的游戏账号在其他地方已出或者不再继续寄售，请务必告知，避免不必要的纠纷。</p>
        <p>3.您若拿不合法账号（骗取或本人恶意找回）来游严选游戏服务网或者其他平台寄售，游严选游戏服务网会对该账号进行拉黑下架处理，并保留追究法律责任的权利。</p>
        <p>4.若买家需要咨询更多商品细节，建议耐心回答，咨询与官网描述不符时，买家有权申请全额退还意向金。</p>
        <p>5.如有买家下单，该订单理论最长等待交易时长为36小时(等待交易时长由买家自由选择)，您需要在等待交易时长内回应。如超出买家选择等待交易时长，默认给予买家全额退款。</p>
        <p class="tips">友情提醒:退款后请勿再交付账号，否则，出现任何损失须由您自己承担责任。</p>
        <p>6.游戏账号交易具有特殊性，平台展示截图仅供参考，交易是否进行由买方上游戏账号验证为准。如出现误差等原因取消，交易平台不承担任何责任。</p>
        <p>7.若发生买家上号验证账号期间出现纠纷，需买卖双方协商处理，平台不参与判定责任；未出协商一致结果之前，您将争议账号售出，视为默认同意买方全额退款。</p>
        <p>8.如因您个人原因无法正常交付账号，由买卖双方协商处理，未出协商一致结果之前，平台不接受任何理由取消订单。</p>
        <p>9.游戏账号发生恶意找回，若您本人找回的，游严选游戏服务网有权提供相关资料，协助有关部门追回损失;若非您本人找回情形，您有义务联系前任号主，若您拒绝配合，将按本人找回处理；若您能提供有效的首任卖家具体信息与交易凭证(包括但不限于卖家收款记录，订单详详情，聊天记录)，平台未追回产生的损失与您无关。</p>
      </div>
      <div
        slot="btn"
        class="myDialog-btn"
        @click="goImRoom"
      >
        知道了
      </div>
    </myDialog>
    <!-- 还价 -->
    <myDialog
      :show="counterofferShow"
      :title="'还价'"
      boxPadding="30px 38px"
      :closeFun="() => {counterofferShow=false}"
      width="446"
      dialog-style="header"
    >
      <div slot="content" class="counteroffer-box">
        <el-form :model="counterofferForm" :rules="counterofferRules" ref="counterofferForm" label-width="90px"  label-position="left" :hide-required-asterisk="true">
          <el-form-item label="卖家还价:" prop="price">
            <el-input placeholder="请输入还价金额" class="counteroffer-input" v-model="counterofferForm.price" :maxlength="7">
              <span v-if="forecast" slot="suffix"> 预计到手¥{{ forecast }}</span></el-input>
          </el-form-item>
          <div class="price-row">
            <div class="left">
              买家出价:<span class="price-icon">￥</span><span class="price">{{rowData.buyer_price}}</span>
            </div>
            <div class="right" v-show="rowData.new_reserve_price > 0" >当前底价:<span class="price-icon">￥</span>{{ rowData.new_reserve_price }}</div>
            <div :class="['right', rowData.new_reserve_price > 0 ? 'right-last' : '']">商品原价:<span class="price-icon">￥</span>{{ rowData.product_price }}</div>
          </div>
        </el-form>
      </div>
      <el-button
        :disabled="disabled" v-preventReClick='1000'
        slot="btn"
        style="padding: 0;border: 0;"
        class="myDialog-btn"
        @click="counterofferSub"
      >
        确认还价
      </el-button>
    </myDialog>
    <!-- 还价二次确认 -->
    <myDialog
      :show="counterofferTextShow"
      :title="'温馨提示'"
      boxPadding="24px 30px"
      :closeFun="() => {counterofferTextShow=false}"
      width="358"
      :text="counterofferText"
      dialog-style="header"
    >
      <div
        slot="btn"
        class="myDialog-btn-group"
      >
        <el-button class="btn-default btn-cancel" @click="counterofferTextShow=false">取消</el-button>
        <el-button :disabled="disabled" v-preventReClick='1000' @click="counteroffer" class="btn-default btn-confirm">确认</el-button>
      </div>
    </myDialog>
    <!-- 同意议价 待添加同意拒绝判断 -->
    <myDialog
      :show="agreeUpsetShow"
      :title="rowData.agree ? '确认同意当前议价吗？' : '确认拒绝当前议价吗'"
      boxPadding="25px 20px 36px"
      :closeFun="agreeUpsetDiaClose"
      width="393"
      dialog-style="header"
    >
      <div slot="content" class="agree-upset-box">
        <div class="agree-product">
          <div class="left">
            <img :src="rowData.image" alt="" />
          </div>
          <div class="right">
            <div class="titlte">
              {{ rowData.product_name }}
            </div>
            <div class="tag">
              <span v-for="item in rowData.category_info" :key="item.value">{{item.value}}</span>
            </div>
            <div class="price">
              <span>￥</span>{{ rowData.product_price }}
            </div>
          </div>
        </div>
        <div
          class="agree-price"
          :style="{backgroundImage: `url(${backgroundImage})`}"
        >
          <div class="buyer-price-text" :style="{'color': rowData.agree ? '#F8A04A' : '#5A5F6B'}">买家出价</div>
          <div class="buyer-price" :style="{'color': rowData.agree ? '#FF9431' : '#5A5F6B'}"><span>￥</span>{{ rowData.buyer_price }}</div>
          <div class="deal-price" v-show="rowData.agree">预计到手¥{{forecast}}</div>
        </div>
        <my-progress class="progress" showWave :rowData="rowData"></my-progress>
      </div>
      <div
        slot="btn"
        class="myDialog-btn"
        @click="agreeUpsetSub(rowData.agree,rowData.id)"
      >
        {{ rowData.agree ? '同意议价' : '狠心拒绝' }}
      </div>
    </myDialog>
    <!-- 验号报告 -->
    <verificationReport
      :show.sync="verificationReportShow"
      :id="rowId"
      :clientType="'seller'"
      :checkStatus="rowDetail.check_status"
      :roomId="rowDetail.room_id"
    >
    </verificationReport>
  </div>
</template>

<script>
import downturnDeatilDia from '@/views/PersonalCenter/components/downturnDeatilDia'
import verificationReport from '@/views/PersonalCenter/components/verificationReport'
import myDialog from "../../../components/myDialog.vue";
import myProgress from "@/components/myProgress";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";
import {
  apiGameList,
  apiEarnestOrderList,
  apiEarnestOrderAgree,
  apiEarnestOrderRefuse,
  apiEarnestOrderDicker,
  apiEarnestOrderDetail,
  apiEarnestOrderUrge,
  apiEarnestOrderSendAccount,
  apiEarnestOrderOff,
  closeRemind,
} from "@/request/API";
import btnGroup from "./components/btnGroup";
import pullPlugUpset from './components/pullPlugUpset'
import { accSub, accMul } from '@/util/calculate.js'

export default {
  name: 'bargainPrice',
  components: {
    downturnDeatilDia,
    myDialog,
    myProgress,
    btnGroup,
    pullPlugUpset,
    verificationReport,
    CommonPagination,
    EmptyState,
  },
  data() {
    return {
      disabled: false,
      query: {
        page: 1,
        pageSize: 5,
        status: 0,
        type: '',
        game_id: '',
        match: '',
      },
      // 列表详情按钮控制
      button_list: [],
      // 验号报告弹窗
      verificationReportShow: false,
      // 终止弹窗
      pullPlugUpsetShow: false,
      // 求降价详情弹窗
      downturnDeatilDiaShow: false,
      // 告知书
      noticeShow: false,
      // tabbar 选中项
      selectItem: "游戏账号",
      // tabbar 选中项Index
      selectItemIndex: 0,
      tabbarItem: [
        "游戏账号",
        // "装备道具"
      ],
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 0,
      //表格数据
      tableData: [],
      //选择时间下拉框
      options: [
        { value: "0", label: "全部" },
        { value: "1", label: "本周内" },
        { value: "2", label: "当月" },
        { value: "3", label: "三个月内" },
        { value: "4", label: "半年内" },
        { value: "5", label: "半年以上" },
        { value: "6", label: "一年内" },
      ],
      //选择游戏下拉框
      selectGame: [],
      // 还价弹窗
      counterofferShow: false,
      counterofferForm: {
        price: '',
      },
      counterofferRules: {
        // price: [
        //   { required: true, message: '请输入价格', trigger: 'blur' },
        // ]
      },
      // 还价二次确认弹窗提示文案
      counterofferText: '',
      // 还价二次确认弹窗
      counterofferTextShow: false,
      // 同意/拒绝当前议价弹窗
      agreeUpsetShow: false,
      // 同意/拒绝背景
      backgroundImage: require('../../../assets/image/PersonalCenter/Seller/BargainPrice/agreeUpsetBg.png'),
      // 当前行数据
      rowData: {},
      // 当前行订单id
      rowId: '',
      // 当前行详情
      rowDetail: {},
      btnFlag: true,
    }
  },
  created() {
    //游戏列表  下拉框
    apiGameList({}).then((res) => {
      this.selectGame = res.data
    });
    if(this.$route.query?.status == 'fail'){
      this.query.status = 2
    }
    this.handleGetData()
  },
  mounted() {
    this.$WS.on('earnestRefresh', (e) => {
      if(e.data.user_type == 2){
        this.handleGetData()
      }
    })
  },
  computed: {
    forecast() {
      if(!this.rowData.id) return ''
      var calculate_price
      if(this.counterofferShow) {
        // 卖家输入价格预估到手价
        let reg = /^\d+$/;
        if (!reg.test(this.counterofferForm.price)) {
          return ''
        }
        if(this.rowData.product_price * 0.65 > this.counterofferForm.price * 1){
          return ''
        }
        if(this.counterofferForm.price > this.rowData.product_price){
          return ''
        }
        calculate_price = this.counterofferForm.price
      } else {
        //  卖家同意卖家出价预估到手价
        calculate_price  = this.rowData.buyer_price
      }

      var agent = accMul(calculate_price, this.rowData.agent_fee/100)
      if(agent < this.rowData.agent_fee_min)  agent = this.rowData.agent_fee_min
      if(agent > this.rowData.agent_fee_max)  agent = this.rowData.agent_fee_max
      var income = accSub(calculate_price, agent)
      return income < 0 ? '' : income
    }
  },
  methods: {
    /**
     * @description: 催促倒计时
     * @param {*} item
     * @return {*}
     */
    nextUrgeTimeChange(item) {
      this.handleGetData()
    },
    /**
     * @description: 提醒买家
     * @return {*}
     */
    closeRemindClick(id) {
      this.downturnDeatilDiaShow = false
      closeRemind({id}).then(res => {
        this.$message({
          message: res.msg,
          center: true,
          offset: 350,
          customClass: 'counteroffer-msg',
        })
      }).catch(err => {
        this.$message({
          message: err.msg,
          center: true,
          offset: 350,
          customClass: 'counteroffer-msg',
        })
      })
    },
    /**
     * @description: 倒计时结束调用终止
     * @param {*} id
     * @return {*}
     */
    payOverTime(id){
      apiEarnestOrderOff({
        id: id,
        reason: '其他',
        time_out: 1
      }).then(res => {
        this.handleGetData()
      }).catch()
    },
    /**
     * @description: 验号报告
     * @param {*} id
     * @return {*}
     */
    handleVerificationReport(id) {
      this.downturnDeatilDiaShow = false
      this.verificationReportShow = true
      this.rowId = id
    },
    /**
     * @description: 发送账密告知书-跳转聊天室
     * @return {*}
     */
    goImRoom() {
      if(this.btnFlag){
        this.btnFlag = false
        apiEarnestOrderSendAccount({
          id: this.rowId
        }).then(res => {
          if(res.data.room_id){
            this.noticeShow = false
            this.$openIM({
              im_type: 3,
              roomId: res.data.room_id
            })
          } else {

          }
          this.handleGetData()
        }).catch(e => {
          if(e.code == 10012){
            this.$message.error(e.msg)
            this.handleGetData()
          }
        }).finally(() => {
          this.noticeShow = false
          setTimeout(() => {
            this.btnFlag = true
          }, 1000)
        })
      }
    },
    /**
     * @description: 发送账密
     * @param {*} item
     * @return {*}
     */
    handleSendPsd(item) {
      this.downturnDeatilDiaShow = false
      this.rowId = item.id
      this.rowData = item
      this.noticeShow = true
    },
    /**
     * @description: 还价
     * @param {*} item
     * @return {*}
     */
    handleCounteroffer(item) {
      this.downturnDeatilDiaShow = false
      this.rowData = item
      this.counterofferForm.price = ''
      this.counterofferShow = true
    },
    /**
     * @description: 终止弹窗
     * @param {*} id 订单id
     * @return {*}
     */
    handlePullPlugUpset(id) {
      this.rowId = id
      this.pullPlugUpsetShow = true
      this.downturnDeatilDiaShow = false
    },
    /**
     * @description: 同意拒绝弹窗关闭
     * @return {*}
     */
    agreeUpsetDiaClose() {
      this.agreeUpsetShow = false
      this.rowData = {}
    },
    /**
     * @description: 同意
     * @param {*} key 1：同意 2： 拒绝
     * @param {*} item 当前行数据
     * @return {*}
     */
    handleAgreeUpset(key, item) {
      this.rowData = JSON.parse(JSON.stringify(item))
      this.rowData.agree = key == 1
      if(key == 1) {
        this.backgroundImage = require('../../../assets/image/PersonalCenter/Seller/BargainPrice/agreeUpsetBg.png')
      } else {
        this.backgroundImage =  require('../../../assets/image/PersonalCenter/Seller/BargainPrice/refuseUpsetBg.png')
        this.rowData.status = 2
      }
      this.downturnDeatilDiaShow = false
      this.agreeUpsetShow = true
    },
    /**
     * @description: 搜索
     * @return {*}
     */
    handleSearch() {
      this.query.page = 1
      this.handleGetData()
    },
    /**
     * @description: 催促
     * @return {*}
     */
    hasten(id) {
      apiEarnestOrderUrge({
        id
      }).then(res => {
        this.$message({
          message: res.msg,
          center: true,
          offset: 350,
          customClass: 'counteroffer-msg',
        })
        this.downturnDeatilDiaShow = false
        this.handleGetData()
      }).catch(e => {
        if(e.code == 10012){
          this.$message.error(e.msg)
          this.handleGetData()
          this.downturnDeatilDiaShow = false
        } else {
          this.$message.error(e.msg)
        }
      })
    },
    /**
     * @description: 行点击
     * @return {*}
     */
    tableRowClick(item) {
      apiEarnestOrderDetail({
        id: item.id
      }).then(res =>{
        this.rowDetail = res.data
        this.button_list = res.data.button_list
        this.downturnDeatilDiaShow = true
      }).catch(e => {
        if(e.code == 10012){
          this.$message.error(e.msg)
          this.handleGetData()
        }
      })
    },
    /**
     * @description: 同意/拒绝还价提交
     * @param {*} key true： 同意 false：拒绝
     * @param {*} id 订单id
     * @return {*}
     */
    agreeUpsetSub(key, id) {
      // 待添加同意拒绝判断
      this.agreeUpsetShow = false
      if(key){
        // 同意
        apiEarnestOrderAgree({id}).then(res => {
          this.$message({
            message: res.data,
            center: true,
            offset: 350,
            customClass: 'counteroffer-msg',
          })
          this.handleGetData()
          this.downturnDeatilDiaShow = false
        }).catch(e => {
          if(e.code == 10012){
            this.$message.error(e.msg)
            this.handleGetData()
            this.downturnDeatilDiaShow = false
          }
        })
      } else {
        // 拒绝
        apiEarnestOrderRefuse({id}).then(res => {
          this.$message({
            message: res.data,
            center: true,
            offset: 350,
            customClass: 'counteroffer-msg',
          })
          this.handleGetData()
          this.downturnDeatilDiaShow = false
        }).catch(e => {
          if(e.code == 10012){
            this.$message.error(e.msg)
            this.handleGetData()
            this.downturnDeatilDiaShow = false
          }
        })
      }
    },
    /**
     * @description: 还价提交
     * @return {*}
     */
    counterofferSub(){
      if(this.counterofferForm.price == ''){
        return this.$message.error('请输入您的还价')
      }
      let reg = /^\d+$/;
      if (!reg.test(this.counterofferForm.price)) {
        return this.$message({
          message: "议价金额不支持小数、负数和字符",
          customClass: "counteroffer-msg",
        });
      }
      // 还价金额不得低于商品金额的65%判断和提示
      if(this.rowData.product_price * 0.65 > this.counterofferForm.price * 1){
        return this.$message.error('金额不得低于商品金额的65%')
      }
      if(this.counterofferForm.price > this.rowData.product_price){
        return this.$message.error('您的还价已超出原价，请重新出价！')
      }
      // 是否有底价判断
      if(this.rowData.new_reserve_price > 0 && this.counterofferForm.price != this.rowData.new_reserve_price){
        this.counterofferShow = false
        // 有底价
        if(this.counterofferForm.price > this.rowData.new_reserve_price){
          // 还价高于底价
          this.counterofferText = '当前还价金额高于您已同意的底价，该底价已向买家透出，请确认是否继续还价～'
        } else {
          // 还价低于底价
          this.counterofferText = '当前还价金额低于您已同意的底价，底价金额将被更新，是否确认继续出价～'
        }
        this.counterofferTextShow = true
      } else {
        // 无底价
        this.counteroffer()
      }

    },
    /**
     * @description: 还价接口调用
     * @return {*}
     */
    counteroffer(){
      apiEarnestOrderDicker({
        id: this.rowData.id,
        price: this.counterofferForm.price
      }).then(res => {
        this.$message({
          message: res.data,
          center: true,
          offset: 350,
          customClass: 'counteroffer-msg',
        })
        this.handleGetData()
        this.counterofferTextShow = false
        this.downturnDeatilDiaShow = false
        this.counterofferShow = false
      }).catch(e => {
        if(e.code == 10012){
          this.$message.error(e.msg)
          this.handleGetData()
          this.counterofferTextShow = false
          this.downturnDeatilDiaShow = false
          this.counterofferShow = false
        }
      })
    },
    //初始化数据
    handleGetData() {
      // 账号列表
      apiEarnestOrderList(this.query).then((res) => {
        this.tableData = res.data.list;
        this.totalCount = res.data.total;
      });
    },
    // item切换
    clickItem(item, index) {
    },
    handleCurrentChange(val) {
      this.query.page = val
      this.handleGetData()
    },
  },
}
</script>

<style lang="less" scoped>
.bargainPriceBox{
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 620px;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after{
    box-sizing: border-box;
  }

  .tabbar {
    min-height: 40px;
    height: auto;
    margin-top: 0;
    padding: 4px 0 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;

    #tabbar {
      display: flex;
      align-items: center;
      gap: 8px;

      .tabbarItem {
        min-width: 76px;
        height: 34px;
        margin-right: 0;
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 20px;
        cursor: pointer;
        transition: color .2s ease, background .2s ease, box-shadow .2s ease;
      }

      .tabbarItem:hover {
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }

      .isAcitve,
      .isAcitve:hover {
        padding-bottom: 0;
        color: #FFFFFF;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        background: var(--bg-dark, #1A1D24);
        box-shadow: inset 0 -3px 0 var(--primary, #FF5A1F);
      }

      .tabbarItem:last-of-type {
        margin: 0;
      }
    }

    .filter_search {
      width: 318px;
      height: 40px;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      position: static;
      overflow: hidden;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      transition: border-color .2s ease, box-shadow .2s ease;

      &:focus-within{
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .filter_search_input {
        width: 100%;
        min-width: 0;
        height: 38px;
        background: transparent;
        border: none;
        outline: none;
        padding: 0 16px;
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        color: var(--text-main, #111827);
      }

      .filter_search_input::-webkit-input-placeholder {
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: var(--text-muted, #9AA0AC);
      }

      .filter_search_btn {
        position: static;
        width: 92px;
        height: 32px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        font-size: 14px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
        cursor: pointer;
        transition: background .2s ease;
      }

      .filter_search_btn:hover {
        background: var(--primary-hover, #E84A12);
      }
    }
  }
  .filter {
    min-height: 40px;
    height: auto;
    margin: 18px 0 14px;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;

    .select_ground {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;

      /deep/ .el-input__inner {
        width: 180px;
        height: 40px;
        padding: 0 34px 0 14px;
        background: var(--bg-card, #FFFFFF);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }

      /deep/ .el-input.is-focus .el-input__inner,
      /deep/ .el-input__inner:focus {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/ .popper__arrow {
        left: 155px !important;
      }

      /deep/ .el-select-dropdown {
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }

      /deep/ .el-select-dropdown__item {
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/ .el-select-dropdown__item.hover,
      /deep/ .el-select-dropdown__item:hover {
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/ .el-select-dropdown__item.selected {
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }

      .select_data,
      .select_game,
      .select_status,
      .select_Pstatus {
        margin-right: 0;
      }
    }

    .filter_search {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;

      .filter_search_input {
        width: 160px;
        height: 40px;
        background: var(--bg-tag, #F0EDE8);
        border-radius: 4px;
        border: none;
        padding: 0 120px 0 20px;
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
      }

      .filter_search_input::-webkit-input-placeholder {
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: var(--text-muted, #9AA0AC);
      }

      .filter_search_btn {
        position: absolute;
        top: 0;
        left: 200px;
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  .status-filter {
    height: 42px;
    margin-bottom: 18px;
    padding: 4px;
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    gap: 6px;

    /deep/.el-radio-button {
      .el-radio-button__inner {
        min-width: 92px;
        height: 32px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        border-radius: 4px;
        box-shadow: none;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 20px;
        transition: color .2s ease, background .2s ease, box-shadow .2s ease;
      }

      .el-radio-button__inner:hover {
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }

      &.is-active {
        .el-radio-button__inner {
          color: #FFFFFF !important;
          background: var(--bg-dark, #1A1D24) !important;
          border-color: transparent;
          box-shadow: inset 0 -3px 0 var(--primary, #FF5A1F);
        }
      }
    }

    /deep/.el-radio-button:first-child .el-radio-button__inner,
    /deep/.el-radio-button:last-child .el-radio-button__inner {
      border-radius: 4px;
    }
  }

  .product {
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    &-list {
      min-height: 420px;
      padding: 0;
      &-item {
        min-height: 164px;
        border-top: 1px solid var(--border-soft, #E8E4DE);
        padding: 20px;
        display: flex;
        align-items: center;
        gap: 20px;
        cursor: pointer;
        transition: background .2s ease, box-shadow .2s ease;

        &:first-child {
          border-top: none;
        }

        &:hover {
          background: var(--bg-tag, #F0EDE8);
          box-shadow: inset 3px 0 0 var(--primary, #FF5A1F);
        }

        .left-image {
          width: 160px;
          height: 112px;
          flex: 0 0 160px;
          object-fit: cover;
          background: var(--bg-tag, #F0EDE8);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          box-shadow: 0 8px 18px rgba(26, 29, 36, 0.08);
        }
        .order {
          width: calc(100% - 180px);
          min-width: 0;
          &-num {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 500;
            color: var(--text-secondary, #5A5F6B);
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            gap: 16px;
            img {
              width: 20px;
              height: 20px;
            }
            &-left{
              display: flex;
              align-items: center;
              min-width: 0;
              color: var(--text-secondary, #5A5F6B);
              img{
                margin-right: 5px;
              }

              span{
                height: 24px;
                padding: 0 10px;
                display: inline-flex;
                align-items: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                background: var(--bg-tag, #F0EDE8);
                border: 1px solid var(--border-soft, #E8E4DE);
                border-radius: 4px;
                line-height: 22px;
              }
            }
            &-right{
              color: var(--text-secondary, #5A5F6B);
              font-family: PingFang SC;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              flex-wrap: wrap;
              gap: 8px 0;
              flex-shrink: 0;
              min-height: 28px;
              .my-counteroffer{
                color: var(--primary, #FF7A1A);
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
                margin-left: 12px;
                padding: 3px 10px;
                background: var(--primary-soft, #FCEDE5);
                border-radius: 4px;
                .price-icon{
                  font-size: 13px;
                  font-weight: 500;
                }
                .price-text{
                  font-size: 18px;
                  font-weight: 500;
                }
              }
              .agree{
                border-radius: 4px;
                background: var(--bg-tag, #F0EDE8);
                min-width: 56px;
                height: 22px;
                padding: 0 8px;
                text-align: center;
                line-height: 22px;
                margin-left: 8px;
                color: var(--new, #00C16E);
                font-family: PingFang SC;
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
              }
              .refund{
                border-radius: 4px;
                background: var(--danger-soft, #FEF2F2);
                min-width: 56px;
                height: 22px;
                padding: 0 8px;
                text-align: center;
                line-height: 22px;
                margin-left: 8px;
                color: var(--danger, #EF4444);
                font-family: PingFang SC;
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
              }
            }
          }
          &-title {
            margin: 14px 0 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 24px;
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 500;
            color: var(--text-main, #111827);
            line-height: 24px;
          }
          .rowData-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            min-width: 0;
            font-family: PingFang SC-Regular, PingFang SC;

            /deep/.progress {
              width: 390px;
              flex: 0 0 390px;
            }

            /deep/.progress-label-item {
              white-space: nowrap;
            }

            /deep/.btn-group {
              min-width: 260px;
              flex: 1 1 auto;
            }
          }
        }
      }
    }
    //分页
    .pages {
      width: 100%;
      min-height: 88px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bg-card, #FFFFFF);
      border-top: 1px solid var(--border-soft, #E8E4DE);
    }
  }
  .no_data {
    min-height: 300px;
    padding: 64px 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
  }
  .notice-content{
    height: 359px;
    overflow-y: scroll;
    padding-right: 4px;
    color: var(--text-secondary, #5A5F6B);
    font-family: PingFang SC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    .tips{
      color: var(--primary, #FF5A1F);
    }
    &::-webkit-scrollbar {
      width: 8px;  /* 滚动条宽度 */
    }

    &::-webkit-scrollbar-track {
      background-color: var(--bg-tag, #F0EDE8);  /* 滚动条背景色 */
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--border-strong, #D8D2CA);  /* 滚动条滑块颜色 */
      border-radius: 4px;
    }
  }
  .myDialog-btn {
    width: 200px;
    height: 40px;
    line-height: 40px;
    border-radius: 3px;
    text-align: center;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    background: var(--primary, #FF5A1F);
    color: #FFFFFF;
    cursor: pointer;
    border: none;
    transition: background 0.2s ease, opacity 0.2s ease;
  }
  .myDialog-btn:hover {
    background: var(--primary-hover, #E84A12);
  }
  .myDialog-btn-group{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .btn-default{
      width: 140px;
      height: 40px;
      padding: 0;
      border-radius: 3px;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      color: var(--text-main, #1A1D24);
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
    }
    .btn-cancel{
      background: var(--bg-card, #FFFFFF);
    }
    .btn-cancel:hover{
      background: var(--bg-tag, #F0EDE8);
    }
    .btn-confirm{
      border-color: transparent;
      background: var(--primary, #FF5A1F);
      color: #FFFFFF;
    }
    .btn-confirm:hover{
      background: var(--primary-hover, #E84A12);
    }
  }
  .counteroffer-box{
    width: 100%;
    margin: 10px 0 30px;
    .el-form-item{
      margin-bottom: 14px;
    }
    /deep/.el-form-item__label{
      color: var(--text-secondary, #5A5F6B);
      text-align: left;
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: 42px;
      padding: 0;
    }
    /deep/.el-input__suffix{
      right: 20px;
    }
    .counteroffer-input{
      width: 100%;

      /deep/.el-input__inner{
        height: 42px;
        padding: 0 132px 0 14px;
        background: var(--bg-tag, #F0EDE8);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
      }

      /deep/.el-input__inner:focus{
        border-color: var(--primary, #FF5A1F);
        background: #FFFFFF;
        box-shadow: none;
      }

      /deep/.el-input__suffix{
        color: var(--primary, #FF7A1A);
        font-size: 13px;
      }
    }
    .price-row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px 12px;
      padding: 14px;
      color: var(--text-secondary, #5A5F6B);
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      background: var(--bg-tag, #F0EDE8);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      .left{
        margin-left: 0;
        width: 50%;
        span{
          color: var(--primary, #FF7A1A);
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0.28px;
        }
        .price-icon{
          margin-left: 10px;
        }
        .price{
          font-size: 22px;
        }
      }
      .right-last{
        margin-top: 0;
        margin-left: 0;
      }
      .right {
         .price-icon{
          margin-left: 10px;
        }
      }
    }
  }
  .agree-upset-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 12px 0 28px;
    .agree-product{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 14px;
      background: var(--bg-tag, #F0EDE8);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      .left{
        min-width: 135px;
        height: 90px;
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .right{
        margin-left: 13px;
        min-width: 0;
        .titlte{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          color: var(--text-main, #111827);
          text-overflow: ellipsis;
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 0.28px;
        }
        .tag{
          color: var(--text-muted, #9AA0AC);
          font-family: PingFang SC;
          font-size: 10px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0.2px;
          margin: 5px 0 7px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 187px;
          span+span{
            margin-left: 5px;
          }
        }
        .price{
          color: var(--primary, #FF7A1A);
          font-family: PingFang SC;
          font-style: normal;
          letter-spacing: 0.2px;
          font-size: 16px;
          font-weight: 700;
          display: flex;
          align-items: center;
          span{
            font-size: 10px;
            font-weight: 400;
          }
        }
      }
    }
    .agree-price{
      margin-top: 25px;
      width: 346.613px;
      height: 47.347px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-repeat: no-repeat;
      background-size: cover;
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.08);
      .buyer-price-text{
        // color: #F8A04A;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-right: 10px;
      }
      .buyer-price{
        // color: #FF9431;
        text-align: right;
        font-family: PingFang SC;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        display: flex;
        align-items: center;
        span{
          font-size: 15px;
          font-weight: 400;
        }
      }
      .deal-price{
        position: absolute;
        left: 250px;
        // width: 56px;
        padding: 0 10px;
        height: 18px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px 4px 4px 0px;
        background: linear-gradient(107deg, #FF9F1A 0%, #FF5F2D 100%);
        color: #FFF;
        font-family: PingFang SC;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px;
        transform: translateY(-17px);
      }
    }
    .progress{
      width: 347px;
      margin-top: 20px;
    }
  }
  .downturn-group-btn{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    .btn{
      display: flex;
      min-width: 64px;
      height: 32px;
      padding: 0 14px;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      color: var(--text-main, #1A1D24);
      background: var(--bg-card, #FFFFFF);
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
    .el-button+.el-button{
      margin-left: 0;
    }
    .border-5B5B5B{
      border-color: var(--bg-dark, #1A1D24);
    }
    .bg-FFDB51{
      border-color: transparent;
      color: #FFFFFF;
      background: var(--bg-dark, #1A1D24);
      box-shadow: none;
    }
    .w-88{
      width: 88px !important;
    }
    .ing{
      margin-right: 5px;
      display: flex;
      align-items: center;
      color: var(--primary, #FF7A1A);
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.24px;
      img{
        width: 17px;
        height: 17px;
        margin-right: 5px;
      }
    }
  }
}

</style>
<style lang="less">
.counteroffer-msg{
  border-radius: 4px;
  background: var(--danger-soft, #FEF2F2);
  padding: 10px 43px;
  .el-message__icon {
    display: none;
  }
  .el-message__content{
    color: var(--danger, #EF4444);
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
